module.exports = __webpack_public_path__ + "img/icon-play.56f00205.svg";